import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const MasterLayout = ({ children }) => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [user, setUser] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null); // Track which dropdown is open
  const location = useLocation(); // Hook to get the current route
  const navigate = useNavigate();

  useEffect(() => {
    const getUser = () => {
      try {
        const userStr = localStorage.getItem('adminUser');
        if (!userStr || userStr === 'undefined' || userStr === 'null') {
          return null;
        }
        return JSON.parse(userStr);
      } catch (error) {
        console.error('Error parsing adminUser from localStorage:', error);
        return null;
      }
    };
    setUser(getUser());
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/sign-in');
  };

  // Handle dropdown toggle
  const handleDropdownToggle = (dropdownKey) => {
    setOpenDropdown(openDropdown === dropdownKey ? null : dropdownKey);
  };

  // Auto-open dropdown containing active route
  useEffect(() => {
    if (location.pathname.startsWith('/vitrin/')) {
      setOpenDropdown('vitrin');
      return;
    }
    const dropdowns = {
      'users': ['/users/all', '/users/owners', '/users/staff', '/users/customers'],
      'organizations': ['/organizations/active', '/organizations/inactive', '/organizations/subscription', '/organizations/demo', '/organizations/bulk-upload', '/organizations/listed-add', '/organizations/authorizations'],
      'categories': ['/categories', '/categories/add'],
      'plans': ['/plans/list', '/plans/create', '/plans/stats'],
      'popups': ['/popups', '/popups/add'],
      'partners': ['/partners/applications', '/partners/list', '/partners/contracts', '/customers/potential'],
      'earnings-management': ['/earnings/manage', '/earnings/add'],
      'payments': ['/earnings', '/payments/send', '/earnings/pending-payments', '/earnings/paid', '/payments'],
      'announcements': ['/announcements', '/announcements/add'],
      'documents': ['/documents', '/documents/upload'],
      'banners': ['/banners', '/banners/add']
    };

    for (const [key, paths] of Object.entries(dropdowns)) {
      if (paths.some(path => location.pathname === path || location.pathname.startsWith(path + '/'))) {
        setOpenDropdown(key);
        break;
      }
    }
  }, [location.pathname]);

  const sidebarControl = () => {
    setSidebarActive(!sidebarActive);
  };

  const mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  // Overlay'e tıklayınca menüyü kapat
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('overlay') && mobileMenu) {
      setMobileMenu(false);
    }
  };

  return (
    <section 
      className={mobileMenu ? "overlay active" : "overlay "}
      onClick={handleOverlayClick}
    >
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/dashboard' className='sidebar-logo'>
            <img
              src='https://panel.randuapp.com/assets/images/logo.svg?v=1762372289237'
              alt='Randu Logo'
              className='light-logo'
              style={{ maxHeight: '40px', width: 'auto' }}
            />
            <img
              src='https://panel.randuapp.com/assets/images/logo.svg?v=1762372289237'
              alt='Randu Logo'
              className='dark-logo'
              style={{ maxHeight: '40px', width: 'auto' }}
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            <li>
              <NavLink
                to='/dashboard'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:home-smile-angle-outline' className='menu-icon' />
                <span>Dashboard</span>
              </NavLink>
            </li>

            <li className='sidebar-menu-group-title'>Yönetim</li>
            
            {/* Kullanıcılar - Dropdown */}
            <li className={`dropdown ${openDropdown === 'users' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('users'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:users-group-rounded-outline' className='menu-icon' />
                <span>Kullanıcılar</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/users/all' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Tümü</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/users/owners' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Owner Kullanıcılar</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/users/staff' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Personeller</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/users/customers' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Müşteriler</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Organizasyonlar - Dropdown */}
            <li className={`dropdown ${openDropdown === 'organizations' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('organizations'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:buildings-2-outline' className='menu-icon' />
                <span>Organizasyonlar</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/organizations/active' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Aktif</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/organizations/inactive' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Pasif</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/organizations/subscription' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Abonelik</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/organizations/demo' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Demo</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/organizations/bulk-upload' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Toplu Yükle</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/organizations/listed-add' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Listelemeye Organizasyon Ekle</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/organizations/authorizations' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Yetkilendirmeler</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Kategoriler - Dropdown */}
            <li className={`dropdown ${openDropdown === 'categories' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('categories'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:tag-outline' className='menu-icon' />
                <span>Kategoriler</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/categories' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Kategoriler</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/categories/add' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Kategori Ekle</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Planlar */}
            <li className={`dropdown ${openDropdown === 'plans' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('plans'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:wallet-money-outline' className='menu-icon' />
                <span>Planları Yönet</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/plans/list' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Planları Listele</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/plans/create' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Plan Oluştur</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/plans/stats' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Plan İstatistikleri</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Vitrin (randu.app — tüm organizasyonlar) */}
            <li className={`dropdown ${openDropdown === 'vitrin' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('vitrin'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:shop-2-outline' className='menu-icon' />
                <span>Vitrin</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/vitrin/claims' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Sahiplenme Talepleri</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/vitrin/edit-suggestions' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Düzenlenme Önerileri</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/vitrin/leads' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Gelen Randevu Talepleri</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/vitrin/customer-reviews' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Yorumlar</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/vitrin/questions' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Sorular</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/vitrin/complaints' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Şikayetler</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Popuplar - Dropdown */}
            <li className={`dropdown ${openDropdown === 'popups' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('popups'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:notification-unread-outline' className='menu-icon' />
                <span>Popuplar</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/popups' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Popuplar</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/popups/add' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Popup Ekle</span>
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink
                to='/reports'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:chart-outline' className='menu-icon' />
                <span>Raporlar</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/invoices'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:document-text-outline' className='menu-icon' />
                <span>Faturalar</span>
              </NavLink>
            </li>

            <li className='sidebar-menu-group-title'>Partner Yönetimi</li>

            {/* Partnerler - Ana Dropdown */}
            <li className={`dropdown ${openDropdown === 'partners' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('partners'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:users-group-two-rounded-outline' className='menu-icon' />
                <span>Partnerler</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/partners/applications' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Başvurular</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/partners/list' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Partner Listesi</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/partners/contracts' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Sözleşmeler</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/customers/potential' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Potansiyel Müşteriler</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Hak Ediş Yönetimi - Dropdown */}
            <li className={`dropdown ${openDropdown === 'earnings-management' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('earnings-management'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:wallet-money-outline' className='menu-icon' />
                <span>Hak Ediş Yönetimi</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/earnings/manage' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Hak Edişler</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/earnings/add' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Hak Ediş Ekle</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Ödemeler - Dropdown */}
            <li className={`dropdown ${openDropdown === 'payments' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('payments'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:card-send-outline' className='menu-icon' />
                <span>Ödemeler</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/earnings' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Hak Edişler (15 Günlük)</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/payments/send' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Ödeme Gönder</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/earnings/pending-payments' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Ödeme Bekleyenler</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/earnings/paid' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Ödenenler</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/payments' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Tüm Ödemeler</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Duyurular - Dropdown */}
            <li className={`dropdown ${openDropdown === 'announcements' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('announcements'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:notification-unread-outline' className='menu-icon' />
                <span>Duyurular</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/announcements' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Duyuru Listesi</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/announcements/add' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Duyuru Ekle</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Dökümanlar - Dropdown */}
            <li className={`dropdown ${openDropdown === 'documents' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('documents'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:file-text-outline' className='menu-icon' />
                <span>Dökümanlar</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/documents' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Döküman Listesi</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/documents/upload' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Döküman Yükle</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Banner'lar - Dropdown */}
            <li className={`dropdown ${openDropdown === 'banners' ? 'open' : ''}`}>
              <NavLink
                to='#'
                onClick={(e) => { e.preventDefault(); handleDropdownToggle('banners'); }}
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:gallery-outline' className='menu-icon' />
                <span>Banner'lar</span>
                <Icon icon='solar:alt-arrow-down-outline' className='dropdown-icon' />
              </NavLink>
              <ul className='sidebar-submenu'>
                <li>
                  <NavLink to='/banners' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Banner Listesi</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to='/banners/add' className={(navData) => (navData.isActive ? "active-page" : "")}>
                    <span>Banner Ekle</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className='sidebar-menu-group-title'>Randu.app Blog</li>
            <li>
              <NavLink
                to='/blog-randu/posts'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:document-text-outline' className='menu-icon' />
                <span>Blog yazıları</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/blog-randu/categories'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:tag-outline' className='menu-icon' />
                <span>Blog kategorileri</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/blog-randu/tags'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:tag-horizontal-outline' className='menu-icon' />
                <span>Blog etiketleri</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/blog-randu/jobs'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:server-square-outline' className='menu-icon' />
                <span>Blog kuyruğu</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/blog-randu/settings'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:magic-stick-3-outline' className='menu-icon' />
                <span>Blog + Gemini</span>
              </NavLink>
            </li>

            <li className='sidebar-menu-group-title'>İletişim</li>

            {/* Mesajlar */}
            <li>
              <NavLink
                to='/messages'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:chat-round-dots-bold' className='menu-icon' />
                <span>Mesajlar</span>
              </NavLink>
            </li>

            <li className='sidebar-menu-group-title'>Sistem</li>

            <li>
              <NavLink
                to='/settings'
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon='solar:settings-outline' className='menu-icon' />
                <span>Ayarlar</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      {/* Main content */}
      <main className={`dashboard-main ${sidebarActive ? 'active' : ''}`}>
        {/* Header */}
        <div className='header'>
          <div className='container-fluid'>
            <div className='row align-items-center'>
              <div className='col-auto'>
                <button
                  onClick={sidebarControl}
                  type='button'
                  className='sidebar-toggle-btn d-none d-md-block'
                >
                  <Icon icon='radix-icons:hamburger-menu' />
                </button>
                {/* Mobil menü açma butonu */}
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle d-block d-md-none'
                >
                  <Icon icon='radix-icons:hamburger-menu' />
                </button>
              </div>
              <div className='col-auto ms-auto'>
                <div className='d-flex align-items-center gap-3'>
                  {/* Notification dropdown */}
                  <div className='dropdown'>
                    <button
                      className='d-flex justify-content-center align-items-center rounded-circle position-relative'
                      type='button'
                      data-bs-toggle='dropdown'
                    >
                      <Icon
                        icon='solar:bell-outline'
                        className='icon text-xl'
                      />
                      <span className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white'>
                        3
                      </span>
                    </button>
                    <div className='dropdown-menu to-top dropdown-menu-lg p-0'>
                      <div className='px-24 py-16 border-bottom d-flex align-items-center justify-content-between'>
                        <h6 className='mb-0'>Notifications</h6>
                        <Link
                          to='#'
                          className='text-primary-600 fw-semibold text-sm'
                        >
                          Mark all as read
                        </Link>
                      </div>
                      <div className='dropdown-notification-list'>
                        <Link
                          to='#'
                          className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between'
                        >
                          <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                            <span className='w-44-px h-44-px bg-primary-subtle text-primary-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                              <img
                                src='/assets/images/notification/profile-1.png'
                                alt=''
                              />
                            </span>
                            <div>
                              <h6 className='text-md fw-semibold mb-4'>
                                Arlene McCoy
                              </h6>
                              <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                                Invite you to prototyping
                              </p>
                            </div>
                          </div>
                          <span className='text-sm text-secondary-light flex-shrink-0'>
                            23 Mins ago
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* Profile dropdown */}
                  <div className='dropdown'>
                    <button
                      className='d-flex justify-content-center align-items-center rounded-circle'
                      type='button'
                      data-bs-toggle='dropdown'
                    >
                      <img
                        src='/assets/images/user.png'
                        alt='image_user'
                        className='w-40-px h-40-px object-fit-cover rounded-circle'
                      />
                    </button>
                    <div className='dropdown-menu to-top dropdown-menu-sm'>
                      <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                        <div>
                          <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                            {user?.name || 'Admin'}
                          </h6>
                          <span className='text-secondary-light fw-medium text-sm'>
                            {user?.email || 'admin@example.com'}
                          </span>
                        </div>
                        <button type='button' className='hover-text-danger'>
                          <Icon
                            icon='radix-icons:cross-1'
                            className='icon text-xl'
                          />
                        </button>
                      </div>
                      <ul className='to-top-list'>
                        <li>
                          <button
                            onClick={handleLogout}
                            className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3 w-100 text-start border-0 bg-transparent'
                            style={{ cursor: 'pointer' }}
                          >
                            <Icon icon='lucide:power' className='icon text-xl' />{" "}
                            Çıkış Yap
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer section */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© 2024 RanduApp. All Rights Reserved.</p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
